function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "12",
  height: "11",
  viewBox: "0 0 12 11",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M6 .288A5.354 5.354 0 00.646 5.64 5.354 5.354 0 006 10.992a5.354 5.354 0 005.352-5.352A5.354 5.354 0 005.999.288zm-.536 9.596A4.275 4.275 0 011.718 5.64c0-.332.043-.648.112-.958l2.564 2.563v.535c0 .59.481 1.07 1.07 1.07v1.034zm3.693-1.36A1.062 1.062 0 008.14 7.78h-.535V6.175a.537.537 0 00-.535-.535H3.859V4.57h1.07c.294 0 .535-.241.535-.536v-1.07h1.07c.59 0 1.07-.482 1.07-1.07v-.22a4.284 4.284 0 012.677 3.966 4.259 4.259 0 01-1.124 2.884z",
  fill: "#4383BD"
})));